import {Step} from '../types';

interface StepIndicatorProps {
    steps: Step[];
    currentStep: number;
}

export const StepIndicator = ({steps, currentStep}: StepIndicatorProps) => {
    return (
        <div className="flex items-center justify-between mb-8">
            {steps.map((step, index) => (
                <div key={step.number} className="flex items-center flex-1">
                    <div className="flex flex-col items-center flex-1">
                        <div className={`
                            w-10 h-10 rounded-full flex items-center justify-center font-semibold
                            ${currentStep >= step.number
                            ? 'bg-blue-600 text-white'
                            : 'bg-gray-200 text-gray-600'
                        }
                        `}>
                            {step.number}
                        </div>
                        <div className="mt-2 text-center">
                            <p className={`text-sm font-medium ${currentStep >= step.number ? 'text-blue-600' : 'text-gray-600'}`}>
                                {step.title}
                            </p>
                            <p className="text-xs text-gray-500">{step.description}</p>
                        </div>
                    </div>
                    {index < steps.length - 1 && (
                        <div
                            className={`h-1 flex-1 mx-4 ${currentStep > step.number ? 'bg-blue-600' : 'bg-gray-200'}`}
                        />
                    )}
                </div>
            ))}
        </div>
    );
};